import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import CustomButton from "../../Components/CustomButton";
import CustomModal from "../../Components/CustomModal";
import Header from "../../Components/Header";
import { DashboardLayout } from "../../Components/Layout/DashboardLayout";
import Loader from '../../Components/Loader';
import usePagination from "../../Hooks/usePagination";
import useSearch from "../../Hooks/useSearch";
import { useGetIssuesQuery, useResolveIssueMutation } from "../../Redux/Apis/Issue";
import { dateFormatter } from "../../Utils";
import CustomTable from "./../../Components/CustomTable";
import ProfileDisplay from "./../../Components/ProfileDisplay";
import "./style.css";
import FormModal from "../../Components/FormModal";

const sortValues = [
  {
    text: "Name",
    value: "fullName",
  },
  {
    text: "Email",
    value: "email",
  }
];

const perPageValues = [
  {
    text: "8",
    value: 8,
  },
  {
    text: "15",
    value: 15,
  },
  {
    text: "30",
    value: 30,
  }
];

const RaiseIssue = () => {

  const navigate = useNavigate()

  
  const [filters, setFilters] = useState()
  const [showModal, setShowModal] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [showModal3, setShowModal3] = useState(false);
  const [showModal4, setShowModal4] = useState(false);
  const [itemsPerPage, setItemsPerPage] = useState(perPageValues[0].value);
  const [inputValue, setInputValue] = useState('');
  const [selectedId, setSelectedId] = useState();
  const [isFilterOpen, setIsFilterOpen] = useState(false);

  const [sortBy, setSortBy] = useState(sortValues[0].value);
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");

  const [reason, setReason] = useState(false)

  const [search, debouncedSearch, onSearch] = useSearch()
  const { page, perPage, onNext, onPrevious } = usePagination()
  const { data, isLoading, isFetching, refetch } = useGetIssuesQuery({
    page,
    rowsPerPage: perPage,
    search: debouncedSearch,
    sortBy,
    from,
    to,
    ...(filters ? filters : {})
  }, { refetchOnFocus: true });
  const [resolveIssue, { isLoading: isUpdating, isSuccess: isUpdated }] = useResolveIssueMutation();

  const toggleFilter = () => setIsFilterOpen(!isFilterOpen)

  const onChangeFilters = (key, value) => {
    let temp = { ...filters }
    temp[key] = value
    setFilters(temp)
  }

  const FILTER_OPTIONS = [
    {
      label: "Status",
      value: filters?.status,
      setValue: (val) => onChangeFilters("status", val),
      options: [{ label: "All", value: "" }, { label: "Pending", value: "pending" }, { label: "Resolved", value: "resolved" }]
    }
  ]

  useEffect(() => {
    if (isUpdated) {
      setShowModal(false)
      setShowModal2(true)
      setSelectedId()
    }
  }, [isUpdated])

  const onConfirm = async () => {
    await resolveIssue(selectedId)
    refetch()
  }

  useEffect(() => {
    document.title = 'Landing List | Issues';
  }, []);

  const maleHeaders = [
    {
      key: "id",
      title: "Id No",
    },
    {
      key: "profile_name",
      title: "Profile Name",
    },
    {
      key: "reason",
      title: "Reason",
    },
    {
      key: "date",
      title: "Issue Date & Time",
    },
    {
      key: "actions",
      title: "",
    },
  ];

  return (
    <>
      <DashboardLayout>
        <div className="container-fluid">
          <div className="row mb-3">
            <div className="col-12">
              <div className="dashCard">
                <Header
                  title="Raise Issues"
                  search={search}
                  onSearch={onSearch}
                  options={FILTER_OPTIONS}
                />
                <div className="row mb-3">
                  {
                    (isLoading || isFetching) ? <Loader /> :
                      <div className="col-12">
                        <CustomTable
                          headers={maleHeaders}
                          isFilterOpen={isFilterOpen}
                          dateFilter={false}
                          filterSort={false}
                          perPage={true}
                          filterSortValues={sortValues}
                          perPageValues={perPageValues}
                          filterSortValue={sortBy}
                          setFilterSortValue={setSortBy}
                          filterFrom={from}
                          setFilterFrom={setFrom}
                          filterTo={to}
                          setFilterTo={setTo}
                          itemsPerPage={perPage}
                          setItemsPerPage={setItemsPerPage}
                          length={data?.data?.length}
                          page={page}
                          rowsPerPage={perPage}
                          onNext={onNext}
                          onPrevious={onPrevious}
                          total={data?.total}
                        >
                          <tbody>
                            {data?.data?.map((item, index) => (
                              <tr key={item._id}>
                                {/* <td><input type="checkbox" /></td> */}
                                <td>{(index + 1) + ((page - 1) * perPage)}</td>
                                <td>
                                  <ProfileDisplay
                                    name={`${item?.user?.first_name} ${item?.user?.last_name}`}
                                    image={item?.user?.profile_photo}
                                    email={item?.user?.email}
                                  />
                                </td>
                                <td ><p onClick={() => setReason(item?.reason)} className="m-0 cursor-pointer text-underline text-primary">Click to View</p></td>
                                <td> {dateFormatter(item.createdAt)}</td>
                                <td className="d-flex justify-content-end align-items-center">
                                  {/* <p className="m-0 mx-2">View Details</p> */}
                                  <CustomButton variant="primaryButton" text={item.status === "resolved" ? "Resolved" : "Resolve Issue"} className="mx-1" onClick={() => {
                                    if (item.status !== "resolved") {
                                      setShowModal(true)
                                      setSelectedId(item._id)
                                    }
                                  }} />
                                  {
                                    item.status !== "resolved" &&
                                    <>
                                      <CustomButton variant="dangerButton" text="Create a Chatroom" className="mx-1" onClick={() => navigate(`/raise-issues/${item._id}`)} />
                                      <CustomButton variant="primaryButton" text="View Messages" className="mx-1" onClick={() => navigate(`/contract-messages/${item?.booking}`)} />
                                    </>
                                  }
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </CustomTable>
                      </div>
                  }
                </div>
              </div>
            </div>
          </div>
          <CustomModal loading={isUpdating} show={showModal} close={() => { setShowModal(false), setSelectedId() }} action={onConfirm} heading='Are you sure you want to resolve this issue?' />
          <CustomModal show={showModal2} close={() => { setShowModal2(false) }} success heading='Marked as Resolved' />

          <FormModal
            title={`View Reason`}
            open={reason}
            toggle={() => setReason()}
            inputs={[
              { id: "reason", label: "Reason", placeholder: "Enter Reason", required: true, initialValue: reason, disabled: true, type: "textarea" },
            ]}
          />
        </div >
      </DashboardLayout >
    </>
  );
};

export default RaiseIssue
